export const lottery = {
  lotteryPlay: "玩游戏",
  lotteryResults: "结果",
  myLotteryTicket: "我的票",
  lotteryMyTickets: "我的彩票",
  lotteryBackBtn: "返回彩票",
  lotteryMyBets: "我的投注",
  lotteryFloatButtonTitle: "投注",
  lotteryTooltipText: "显示我所有的投注",
  lotteryDraw: "彩票",
  lotteryAnimal: "动物",
  lotterySelectAnimal: "选择动物",
  lotterySelectDraw: "抽奖",
  lotteryAmount: "金额",
  lotteryTotalBet: "总投注",
  lotteryBuyTicket: "购买彩票",
  lotteryCreateTicket: "下注",
  lotteryCreatedTicket: "已下注",
  lotteryErrorTicket: "下注失败",
  lotteryHideResults: "隐藏结果",
  lotteryShowResults: "显示结果",
  lotteryDrawActive: "活动开奖",
  lotteryErrorLoadingData: "加载数据失败",
  lotteryErrorInput: "请添加至少一个投注后进行游戏。",
  lotteryErrorBalance: "余额不足。请充值。",
  lotteryErrorBetAmount: "每个动物的最大投注金额为45 Bs。",
  lotteryErrorSelectDrawAnimal: "请抽奖,选择一个动物并输入有效的投注金额。",
  lotteryMode: "在现代模式下你只能选择最多4个动物。",
  lotteryTicketCreatedMessage: "下注成功",
  lotteryTicketCreatedMessageError: "下注失败",
  lotteryCardGame: "即将",
  lotteryModalCode: "彩票代码",
  lotteryModalDate: "创建日期",
  lotteryModalTotal: "总金额",
  lotteryModalWon: "赢得金额",
  lotteryModalAnimals: "已下注动物",
  lotteryModalTitle: "彩票详情",
  lotteryModalCancel: "取消",
  lotteryModalConfirm: "确定",
  lotteryModalAmount: "金额",
  lotteryModalNoTickets: "没有彩票",
  lotteryTokenNotFound: "找不到彩票",
  lotteryActiveRouletteResults: "即时轮盘结果",
  lotteryGameWinner: "获胜者",
  lotteryGamePrize: "无获奖者",

  lotteryModalInput: "输入您的投注金额",
  lotteryModalAddBet: "添加投注",
  lotteryModalCancelBet: "取消",

  lotteryTraditional: "传统",
  lotteryModern: "现代",
  selectLotteryType: "选择彩票类型",
  result: "结果",
  resultLotteryModern: "现代彩票结果",
  resultLotteryTraditional: "传统彩票结果",
  lotteryDate: "彩票日期",
  lotteryNoResults: "此日期没有结果",
};
